module.exports = __webpack_public_path__ + "img/Unidad16-5.b264e51f.png";